import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Shouye from '@/components/shouye/shouye'
import Sqjy from '@/components/sqjy/sqjy'
import Start from '@/components/start/start'
import Xljy from '@/components/xljy/xljy'
import Lnjy from '@/components/lnjy/lnjy'
import Nmjy from '@/components/nmjy/nmjy'
import Zxkc from '@/components/zxkc/zxkc'
import Xxhd from '@/components/xxhd/xxhd'
import Gjtz from '@/components/gjtz/gjtz'
import Xxxmy from '@/components/xxxmy/xxxmy'
import Online from '@/components/lnjy/online'
import Login from '@/components/login/login'
import Register from '@/components/login/register'
import Forget from '@/components/login/forget'
import Grzx from '@/components/grzx/personal'
import Hot from '@/components/shouye/hot'
import Qk from '@/components/shouye/qk'
import QkDetail from '@/components/shouye/qkdetail'
import Search from '@/components/search/search'
import Fczs from '@/components/gjtz/fczs'
import Hdxq from '@/components/xxhd/hdxq'
import Jfsc from '@/components/jfsc/jfsc'
import SignUp from '@/components/lnjy/signUp'
import articalDetail from '@/components/public/articalDetail.vue'
import articalList from '@/components/public/articalList.vue'
import ClassDetails from '@/components/zxkc/classDetails'
import Fczsdetail from '@/components/public/fczsdetail'
import Zxstudy from '@/components/zxkc/study.vue'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'home',
        component: Home,
        redirect: "/Start",
        children: [
             
        {
            path: 'sqjy',
            name: 'sqjy',
            component: Sqjy
        }, 
        {
            path: 'start',
            name: 'start',
            component: Start
        },{
            path: 'xljy',
            name: 'xljy',
            component: Xljy
        }, {
            path: 'lnjy',
            name: 'lnjy',
            component: Lnjy
        }, {
            path: 'nmjy',
            name: 'nmjy',
            component: Nmjy
        }, {
            path: 'zxkc',
            name: 'zxkc',
            component: Zxkc
        }, {
            path: 'xxhd',
            name: 'xxhd',
            component: Xxhd
        }, {
            path: 'gjtz',
            name: 'gjtz',
            component: Gjtz
        }, {
            path: 'xxxmy',
            name: 'xxxmy',
            component: Xxxmy
        }, {
            path: 'online',
            name: 'online',
            component: Online
        }, {
            path: 'shouye',
            name: 'shouye',
            component: Shouye
        }, {
            path: 'login',
            name: 'login',
            component: Login
        }, {
            path: 'register',
            name: 'register',
            component: Register
        }, {
            path: 'hot',
            name: 'hot',
            component: Hot
        }, {
            path: 'qk',
            name: 'qk',
            component: Qk
        }, {
            path: 'fczs',
            name: 'fczs',
            component: Fczs
        }, {
            path: 'hdxq',
            name: 'hdxq',
            component: Hdxq
        }, {
            path: 'jfsc',
            name: 'jfsc',
            component: Jfsc
        }, {
            path: 'forget',
            name: 'forget',
            component: Forget
        }, {
            path: 'grzx',
            name: 'grzx',
            component: Grzx
        }, {
            path: 'signUp',
            name: 'signUp',
            component: SignUp
        }, {
            path: 'search',
            name: 'search',
            component: Search
        }, {
            path: 'qkdetail',
            name: 'qkdetail',
            component: QkDetail
        }, {
            path: 'artDetail',
            name: 'artDetail',
            component: articalDetail
        }, {
            path: 'articalList',
            name: 'articalList',
            component: articalList
        }, {
            path: 'classDetails',
            name: 'classDetails',
            component: ClassDetails
        }, {
            path: 'fczsdetail',
            name: 'fczsdetail',
            component: Fczsdetail
        }, {
            path: 'zxstudy',
            name: 'zxstudy',
            component: Zxstudy
        }]
    }]


})


// WEBPACK FOOTER //
// ./src/router/index.js